/**
 * @Author：zsj
 * @Date：2022/08/11
 */
import React, { Suspense, useContext } from "react";
import { Layout } from "antd";
// import styles from "./index.less";
import routes from "@/routes";
import RouteRender from "@/routes/route-render";
import Menu from "./menu";
import Header from "./header";
import Footer from "./footer";
import { PermissionCtx } from "@/store/context";
import style from "./index.less";
import LoadingView from "@/components/loading-view";
import { BrowserRouter } from "react-router-dom";

const { Content } = Layout;

const App = () => {
    const { routerArr } = useContext(PermissionCtx);

    return (
        <>
            {
                !routerArr?.length ? (
                    <Suspense fallback={<LoadingView />}>
                        <RouteRender />
                    </Suspense>
                ) : (

                    <Layout>
                        <div className={style.menu} />
                        <Menu />
                        <Layout>
                            <Header />
                            <Suspense fallback={<LoadingView />}>
                                <Content className={style.content}>
                                    <RouteRender />
                                </Content>
                            </Suspense>
                        </Layout>
                    </Layout>
                )
            }
        </>
    );
};

export default App;
